export const SERVICE_FEE_FACTOR = 1.055;
export const TRANSACTION_FEE_THRESHOLD = 5000;
export const TRANSACTION_FEE = 200;
